define(["require", "exports", "./Tenant", "./Address", "./ContactInfo", "./ContactPerson", "./Media/MediaItem"], function (require, exports, Tenant_1, Address_1, ContactInfo_1, ContactPerson_1, MediaItem_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Location = (function () {
        function Location() {
            this.TenantId = "";
            this.Tenant = new Tenant_1.Tenant();
            this.Address = new Address_1.Address();
            this.ContactInfo = new ContactInfo_1.ContactInfo();
            this.CompanyName = "";
            this.Comment = "";
            this.MediaId = null;
            this.MediaItem = new MediaItem_1.MediaItem();
            this.ContactPerson = new ContactPerson_1.ContactPerson();
            this.CreatedAt = new Date();
            this.LastChangeAt = new Date();
        }
        return Location;
    }());
    exports.Location = Location;
});
//# sourceMappingURL=Location.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Location.js
// module id = 156
// module chunks = 0